// Generated by purs version 0.13.0
"use strict";
var Data_Ord = require("../Data.Ord/index.js");
var Data_Ring = require("../Data.Ring/index.js");
var isNextTo = function (v) {
    return function (v1) {
        return Data_Ord.abs(Data_Ord.ordInt)(Data_Ring.ringInt)(v.x - v1.x | 0) <= 1 && Data_Ord.abs(Data_Ord.ordInt)(Data_Ring.ringInt)(v.y - v1.y | 0) <= 1;
    };
};
var doubleDistanceBetween = function (p1) {
    return function (p2) {
        var dy = p1.y - p2.y | 0;
        var dx = p1.x - p2.x | 0;
        return (dx * dx | 0) + (dy * dy | 0) | 0;
    };
};
var adjustPoints = function (v) {
    return [ {
        x: v.x + 1 | 0,
        y: v.y
    }, {
        x: v.x,
        y: v.y + 1 | 0
    }, {
        x: v.x,
        y: v.y - 1 | 0
    }, {
        x: v.x - 1 | 0,
        y: v.y
    }, {
        x: v.x + 1 | 0,
        y: v.y + 1 | 0
    }, {
        x: v.x + 1 | 0,
        y: v.y - 1 | 0
    }, {
        x: v.x - 1 | 0,
        y: v.y + 1 | 0
    }, {
        x: v.x - 1 | 0,
        y: v.y - 1 | 0
    } ];
};
module.exports = {
    adjustPoints: adjustPoints,
    isNextTo: isNextTo,
    doubleDistanceBetween: doubleDistanceBetween
};
